import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ImpersonationService } from '@shared/services/impersonation.service';
import { AuthService } from '@shared/services/auth.service';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-impersonation-banner',
  standalone: true,
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  styles: [`
    /* The site header is position:fixed; top:0; z-index:1030 — a normal-flow
       banner at the top is hidden behind it. Pin this bar to the bottom of the
       viewport above the header so it is always visible during impersonation. */
    .impersonation-bar {
      position: fixed;
      left: 0;
      right: 0;
      bottom: 0;
      z-index: 1050;
    }
  `],
  template: `
    @if (impersonation.isActive()) {
      <div class="impersonation-bar alert alert-warning text-center mb-0 rounded-0 d-flex flex-wrap justify-content-center align-items-center gap-3 py-2 shadow-lg">
        <span>
          Ești în contul lui
          <strong>{{ auth.currentUser()?.first_name }} {{ auth.currentUser()?.last_name }}</strong>
        </span>
        <button class="btn btn-sm btn-dark" [disabled]="exiting()" (click)="exit()">
          @if (exiting()) {
            <span class="spinner-border spinner-border-sm me-1" role="status"></span>
          }
          Ieși din cont
        </button>
      </div>
    }
  `,
})
export class ImpersonationBannerComponent {
  protected readonly impersonation = inject(ImpersonationService);
  protected readonly auth = inject(AuthService);
  protected readonly exiting = signal(false);

  exit() {
    this.exiting.set(true);
    const back = () => {
      this.impersonation.clear();
      window.location.href = environment.staffUrl;
    };
    // Best-effort revoke; return to staff either way (the local token is cleared).
    this.impersonation.exit().subscribe({ next: back, error: back });
  }
}
